import React, { PropsWithChildren } from 'react';
import { HtmlProps } from '../../../../types/HtmlProps';
import { appendClassNames } from '../../../../lib/bemUtils/classname';

export function DownloadDescription({ children, className, ...props }: PropsWithChildren<HtmlProps>) {
  return (
    <figcaption className={appendClassNames('download__description', className)} {...props}>
      {children}
    </figcaption>
  );
}
